import { createFileRoute } from "@tanstack/react-router";
import { analysisMethodsQueryOptions } from "../../app/queries/productQueries";
import { MethodViewer } from "../../app/views/admin/methodViewer";

export const Route = createFileRoute("/admin/methodViewer")({
  component: MethodViewer,
  loader: async ({ context: { queryClient } }) => {
    queryClient.ensureQueryData(analysisMethodsQueryOptions);
  },
});
